export default __webpack_public_path__ + "static/rope-39498a54df33e9a8a167c10d15d621ba.png";